module.exports = __webpack_public_path__ + "static/media/search.f347d386.png";